import PropTypes from 'prop-types';
import React from 'react';
import {
  ListItem,
  Divider,
  Switch,
  ListItemText,
  List,
  Collapse,
  ListItemIcon,
} from '@material-ui/core';
import {Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon} from '@material-ui/icons';

function MilestoneProcedureList(props) {
  const {milestone, importedProject, onToggleEnableMilestone, onToggleEnableProcedure} = props;
  // if procedure id includes in importedProject.milestones array then it's enabled one
  const isMilestoneSelected = !!(importedProject?.milestones || []).find(
    ({id}) => id === milestone.milestone.id,
  );

  return (
    <>
      <ListItem button>
        <ListItemIcon>
          {isMilestoneSelected ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </ListItemIcon>
        <ListItemText primary={milestone.milestone.name} />
        <Switch
          onChange={(_event, isInputChecked) => {
            onToggleEnableMilestone(isInputChecked, milestone.milestone);
          }}
          color="primary"
          checked={isMilestoneSelected}
        />
      </ListItem>
      {milestone.cnsProcedures.length > 0 && (
        <Collapse in timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {milestone.cnsProcedures.map((cnsProcedure) => {
              const isProcedureSelected = !!(importedProject?.importedProcedures || []).find(
                ({id: importedProcedureId}) => importedProcedureId === cnsProcedure.id,
              );

              return (
                <ListItem button key={cnsProcedure.name}>
                  <ListItemIcon>
                    {isProcedureSelected ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </ListItemIcon>
                  <ListItemText primary={cnsProcedure.name} />
                  <Switch
                    onChange={(_event, isInputChecked) => {
                      onToggleEnableProcedure(isInputChecked, cnsProcedure);
                    }}
                    color="primary"
                    checked={isProcedureSelected}
                  />
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      )}
      <Divider style={{marginTop: 15}} />
    </>
  );
}

MilestoneProcedureList.propTypes = {
  milestone: PropTypes.object.isRequired,
  importedProject: PropTypes.object.isRequired,
  onToggleEnableProcedure: PropTypes.func.isRequired,
  onToggleEnableMilestone: PropTypes.func.isRequired,
};

export default MilestoneProcedureList;
